import { connect } from 'react-redux';
import ShowCommentsModalComponent from './../Components/ShowCommentsModalComponent.jsx';
import PropTypes from 'prop-types';
import {
  getModalInfoByOwner,
  getModalVisibility,
} from './../reducers';
import { modal as modalActions } from './../actions';
import { owners } from './../helpers/modals';

export const mapStateToProps = (state, ownProps) => {
  const modalInfo = getModalInfoByOwner(state, owners.commentHistory);
  const visible = getModalVisibility(state, owners.commentHistory);

  const props = {
    visible: visible,
    annotations: !ownProps.buildHealthPage ?
      ownProps.annotations[modalInfo.item.id] || [] :
      ownProps.annotations[modalInfo.dispatcherId] || [],
    glyphFunc: ownProps.glyphFunc,
    ticketsOnly: modalInfo.ticketsOnly
  };

  return props;
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onHide: () => dispatch(modalActions.showCommentHistory(false, {})),
    removeAnnotation: (annotationId) =>
      dispatch(ownProps.removeCommentAction(annotationId)),
    setTicketsOnly: ticketsOnly =>
      dispatch(modalActions.setShowCommentsModalTicketsOnly(ticketsOnly)),
  };
};

const ShowCommentsModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ShowCommentsModalComponent);

ShowCommentsModalContainer.propTypes = { annotations: PropTypes.object.isRequired };

export default ShowCommentsModalContainer;


// WEBPACK FOOTER //
// src/Containers/ShowCommentsModalContainer.jsx